import React, { useEffect, useState } from "react";
import {Link, useLocation} from "react-router-dom";
import {
    FiBriefcase,
    FiClock,
    FiHome,
    FiLogOut,
    FiMessageSquare,
    FiSend,
    FiSettings, FiPhone, FiInfo, FiUser,
} from "react-icons/fi";
import {FaCertificate, FaPeopleArrows, FaQuestion, FaRegMoneyBillAlt, FaUserCircle} from "react-icons/fa";
import LogoMain from '../assets/images/logo-main.png';
import {RouteNames} from "../constants";
import {AuthUserI} from "../interfaces";
import {
    MdEventAvailable,
    MdOutlineCalculate,
    MdOutlineCancel,
    MdOutlineCropLandscape,
    MdWorkOutline
} from "react-icons/md";
import {GiWhistle} from "react-icons/gi";
import {BiTransfer} from "react-icons/bi";

interface PropsI{
    showSideBar: boolean;
    closeSideBar: ()=>void;
    user: AuthUserI
    logout: ()=>void;
}

type MenuItem = {
    title: string;
    iconComponent: React.ReactNode;
    route: string;
    hide?: boolean;
};

const ALLOWED_WHEN_NOT_RECAPTURED = new Set<string>([
    RouteNames.HOME,
    RouteNames.DASHBOARD,
    RouteNames.RECAPTURE,
    RouteNames.RECAPTURE_STATUS,
    RouteNames.REGISTER_COMPLETE,
]);

const Sidebar = ({showSideBar, closeSideBar, user, logout }: PropsI) => {
    const location = useLocation();
    const [currentPagePath, setCurrentPagePath] = useState('')
    const [menuItems, setMenuItems] = useState<MenuItem[]>([]);
    const isRecaptured = !!user?.isRecaptured;
    const isRegistrationIncomplete = !!user?.isRegistrationIncomplete;
    const pinValue = String(user?.pin ?? "").trim();
    const hasValidPin = !!pinValue && pinValue.toLowerCase() !== "null" && pinValue.toLowerCase() !== "undefined" && !isRegistrationIncomplete;

    useEffect(() => {
        setCurrentPagePath(location.pathname);
    }, [location.pathname]);

useEffect(() => {
    if (user) {
        const updatedMenuItems: MenuItem[] = [
            {
              title: "Home",
              iconComponent: <FiHome />,
              route: RouteNames.HOME,
              hide: !hasValidPin,
            },
            {
              title: "Complete Registration",
              iconComponent: <FiUser />,
              route: RouteNames.REGISTER_COMPLETE,
              hide: !isRegistrationIncomplete,
            },
            {
              title: "Request Statement (self)",
              iconComponent: <FiClock />,
              route: RouteNames.REQUEST_STATEMENT,
              hide: !isRecaptured || isRegistrationIncomplete,
            },
            {
                title: "Request Statement (Third Party)",
                iconComponent: <FiClock />,
                route: RouteNames.REQUEST_STATEMENT_THIRD_PARTY,
                hide: !isRecaptured || isRegistrationIncomplete,
            },
            {
              title: "Transactions",
              iconComponent: <FaRegMoneyBillAlt />,
              route: RouteNames.TRANSACTIONS,
              hide: !isRecaptured || isRegistrationIncomplete,
            },
            {
              title: "Refer and Reward",
              iconComponent: <FiSend />,
              route: RouteNames.TRANSFER_RSA,
              hide: !isRecaptured || isRegistrationIncomplete,
            },
            {
              title: "Benefits",
              iconComponent: <MdOutlineCropLandscape />,
                route: RouteNames.TRACK_BENEFIT,
                hide: !isRecaptured || isRegistrationIncomplete,
            },
            {
                title: "Fund Transfer",
                iconComponent: <BiTransfer />,
                route: RouteNames.FUND_TRANSFER,
                hide: !isRecaptured || isRegistrationIncomplete,
            },
            {
                title: "Next of Kin",
                iconComponent: <FaPeopleArrows />,
                route: RouteNames.NEXT_OF_KIN,
                hide: !isRecaptured || isRegistrationIncomplete,
            },
            {
                title: "Beneficiaries",
                iconComponent: <FaPeopleArrows />,
                route: RouteNames.BENEFICIARIES,
                hide: !isRecaptured || isRegistrationIncomplete,
            },
            {
                title: "Pension Calculator",
                iconComponent: <MdOutlineCalculate />,
                route: RouteNames.PENSION_CALCULATOR,
                hide: !isRecaptured || isRegistrationIncomplete,
            },
            {
                title: "Employer",
                iconComponent: <MdWorkOutline />,
                route: RouteNames.EMPLOYER,
                hide: !isRecaptured || isRegistrationIncomplete,
            },
            {
                title: "VNIN",
                iconComponent: <FiBriefcase />,
                route: RouteNames.VIRTUAL_NIN,
                hide: !isRecaptured || isRegistrationIncomplete,
            },
            {
                title: "My Memorable Days",
                iconComponent: <MdEventAvailable />,
                route: RouteNames.MY_MEMORABLE_DAYS,
                hide: !isRecaptured || isRegistrationIncomplete,
            },
            {
                title: "Contribution Missing Months",
                iconComponent: <MdOutlineCancel />,
                route: RouteNames.MISSING_MONTHS,
                hide: !isRecaptured || isRegistrationIncomplete,
            },
            {
                title: "Self Contribution",
                iconComponent: <FaPeopleArrows />,
                route: RouteNames.SELF_CONTRIBUTION,
                hide: user.isMPP === false || !isRecaptured || isRegistrationIncomplete,
            },
            {
                title: "Recapture",
                iconComponent: <FiUser />,
                route: RouteNames.RECAPTURE,
                hide: isRecaptured || isRegistrationIncomplete,
            },
            {
                title: "Recapture Status",
                iconComponent: <FiUser />,
                route: RouteNames.RECAPTURE_STATUS,
                hide: isRecaptured || isRegistrationIncomplete,
            },
            {
                title: "Certificate of Registration",
                iconComponent: <FaCertificate />,
                route: RouteNames.CORG_REQUEST,
                hide: !isRecaptured || isRegistrationIncomplete,
            },
            {
              title: "Feedback",
              iconComponent: <FiMessageSquare />,
              route: RouteNames.FEEDBACK,
              hide: !isRecaptured || isRegistrationIncomplete,
            },
            {
              title: "Whistle Blowing",
              iconComponent: <GiWhistle />,
              route: RouteNames.WHISTLE_BLOWING,
              hide: !isRecaptured || isRegistrationIncomplete,
            },
        ];
    
          setMenuItems(updatedMenuItems);
    }
  }, [user, isRecaptured, isRegistrationIncomplete, hasValidPin]);

    return (
        <div className={`sidebar ${showSideBar ? 'show-side' : ''}`}>
            <div className="sidebar-logo">
                <img src={LogoMain} alt="" style={{
                    width: '100px'
                }}/>
            </div>
            <div className="sidebar-user">
                <div className="">
                    {
                        !user.image ?
                        <FaUserCircle className="sidebar-user-icon" />
                            :
                        <img src={`data:image/png;base64, ${user.image}`} alt="" className="sidebar-user-img" />
                    }
                </div>
                <div className="">
                    <div className="user-name">{`${user.firstName} ${user.surname}`}</div>
                    <div className="user-type">{user.userType}</div>
                </div>
            </div>
            <div className="sidebar-nav">
                { menuItems
                 .filter((item) => !item.hide)
                .map((item, index)=>(
                    <Link
                        to={item.route}
                        key={index}
                        onClick={closeSideBar}
                        className={`nav-item ${item.route === currentPagePath  ? 'active': '' }`}
                    >
                        <div className={`${item.route === currentPagePath ? 'selected-bar': ''}`}></div>
                        <span className={`mr-4 text-xl ${item.route === currentPagePath ? 'font-bold': '' }`}>
                            {item.iconComponent}
                        </span>
                        {item.title}
                    </Link>
                    ))
                }
            </div>
            <div className="sidebar-footer">
                    {hasValidPin && isRecaptured && (
                    <>
                    <Link to={RouteNames.ACCOUNT_SETTINGS} className={`nav-item ${RouteNames.ACCOUNT_SETTINGS === currentPagePath ? 'active': '' }`} onClick={closeSideBar}>
                        <div className={`${RouteNames.ACCOUNT_SETTINGS === currentPagePath ? 'selected-bar': ''}`}></div>
                        <span className={`mr-4 text-xl ${RouteNames.ACCOUNT_SETTINGS === currentPagePath ? 'font-bold': '' }`}>
                            <FiSettings />
                        </span>
                        Account Settings
                    </Link>
                    <Link to={RouteNames.SUPPORT} className={`nav-item ${RouteNames.SUPPORT === currentPagePath ? 'active': '' }`} onClick={closeSideBar}>
                        <div className={`${RouteNames.SUPPORT === currentPagePath ? 'selected-bar': ''}`}></div>
                        <span className={`mr-4 text-xl ${RouteNames.SUPPORT === currentPagePath ? 'font-bold': '' }`}>
                            <FiPhone />
                        </span>
                        Support
                    </Link>
                    <Link to={RouteNames.FAQS} className={`nav-item ${RouteNames.FAQS === currentPagePath ? 'active': '' }`} onClick={closeSideBar}>
                        <div className={`${RouteNames.FAQS === currentPagePath ? 'selected-bar': ''}`}></div>
                        <span className={`mr-4 text-xl ${RouteNames.FAQS === currentPagePath ? 'font-bold': '' }`}>
                            <FaQuestion />
                        </span>
                        FAQs
                    </Link>
                    <Link
  to={RouteNames.PRIVACY}
  className={`nav-item ${RouteNames.PRIVACY === currentPagePath ? 'active' : ''}`}
  onClick={closeSideBar}
  target="_blank"
>
  <div className={`${RouteNames.PRIVACY === currentPagePath ? 'selected-bar' : ''}`}></div>
  <span className={`mr-4 text-xl ${RouteNames.PRIVACY === currentPagePath ? 'font-bold' : ''}`}>
    <FiInfo />
  </span>
  Privacy Policy
</Link>
                    </>
                    )}

                <div className={`nav-item`} onClick={logout}>
                    <span className={`mr-4 text-xl`}>
                            <FiLogOut />
                        </span>
                    Logout
                </div>
            </div>
        </div>
    )
}

export { ALLOWED_WHEN_NOT_RECAPTURED };
export default Sidebar;
